import { Stack } from "@mui/material";
import { BarChart as BarChartIcon } from "@mui/icons-material";

import { LargeContentBox } from "@/components/common/LargeContentBox";
import { PageHeader } from "@/components/common/PageHeader";
import { ManagerContextProvider } from "@/contexts/ManagerContext";
import { QuickStats } from "./components/QuickStats";
import { AdminDashboardFilterBar } from "./components/AdminDashboardFilterBar";
import { ConsultationsBillingSection } from "./components/ConsultationsBillingSection";
import { useAdminDashboardFilters } from "./hooks/useAdminDashboardFilters";

export function AdminInsightsPage() {
  const filters = useAdminDashboardFilters();

  return (
    <ManagerContextProvider>
      <LargeContentBox>
        <Stack spacing={3} width="100%">
          <PageHeader title="Insights administrativos" icon={BarChartIcon} />

          <QuickStats />

          <AdminDashboardFilterBar
            selectedDate={filters.selectedDate}
            dateFilterType={filters.dateFilterType}
            onDateChange={filters.handleDateChange}
            onFilterTypeChange={filters.handleFilterTypeChange}
            onResetAll={filters.resetAll}
            hasActiveFilters={filters.hasActiveFilters}
          />

          <ConsultationsBillingSection
            dateRange={filters.appliedFilters.dateRange}
          />
        </Stack>
      </LargeContentBox>
    </ManagerContextProvider>
  );
}
